import React from "react";
import styled from "styled-components";
import { colors } from "../styles/colors";

const FooterWrapper = styled.footer`
  padding: 60px 20px;
  text-align: center;
  background-color: #0b2b22; /* Deeper tone of brand green */
  border-top: 1px solid ${colors.borderGold};
  color: rgba(255,255,255,0.6);
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
`;

const QuickLinks = styled.div`
  margin-bottom: 30px;
  a {
    margin: 0 15px;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    transition: color 0.3s ease;
    
    &:hover {
      color: ${colors.primary};
    }
  }
`;

const InfoText = styled.p`
  margin: 8px 0;
  letter-spacing: 0.02em;
`;

export default function Footer() {
  return (
    <FooterWrapper>
      <QuickLinks>
        <a href="#about">About</a>
        <a href="#services">Services</a>
        <a href="#video">Consultation</a>
        <a href="#team">Team</a>
        <a href="#contact">Contact</a>
      </QuickLinks>
      <InfoText>Email: info@salehasafdarglobalconsulting.com &nbsp;|&nbsp; Phone: +971509133007</InfoText>
      <InfoText style={{ marginTop: '20px', opacity: 0.4 }}>
        © 2026 Saleha Safdar Global Consulting Services.
      </InfoText>
    </FooterWrapper>
  );
}